module.exports = __webpack_public_path__ + "img/book.bfe74bf9.png";